// Central brand configuration — update links here without touching the code.
export const BRAND = {
  name: "Bloom Beauty Concept Hair",
  professional: "Monique Santos",
  phoneDisplay: "+351 963 085 891",
  phoneIntl: "351963085891",
  instagram: "@monique_santoshairstylist",
  instagramUrl: "https://www.instagram.com/monique_santoshairstylist?stkn=dDZnd3N6bXNjeGdp",
  addressLines: ["Rua Casal dos Ninhos 1B", "Venda do Pinheiro", "2665-536"],
  mapsQuery:
    "https://www.google.com/maps/search/?api=1&query=Rua+Casal+dos+Ninhos+1B,+Venda+do+Pinheiro,+2665-536",
};

// Google integration — official Bloom Beauty Concept Hair profile (Venda do Pinheiro).
// GOOGLE_BUSINESS_URL opens the real profile on Google Maps (name + address query
// resolves to the official listing: 5.0 stars, 2 reviews).
export const GOOGLE_BUSINESS_URL =
  "https://www.google.com/maps/search/?api=1&query=Bloom+Beauty+Concept+Hair,+Rua+Casal+dos+Ninhos+1B,+2665-536+Venda+do+Pinheiro";
// TODO: paste the official "Ask for reviews" link from the Google Business Profile
// dashboard (format: https://g.page/r/XXXXXX/review) to send clients straight into
// the review box. Until then the review buttons open the official profile,
// where the "Avaliar" option is one tap away.
export const GOOGLE_REVIEW_URL = null;

export const waLink = (message) =>
  `https://wa.me/${BRAND.phoneIntl}?text=${encodeURIComponent(message)}`;

// Fixed (language-independent) service registry
export const SERVICE_SLUGS = [
  "cortes-finalizacao",
  "coloracao",
  "mechas-balayage",
  "correcao-de-cor",
  "tratamentos-capilares",
  "cronograma-capilar",
  "botox-alinhamento",
  "progressiva-alisamentos",
  "depilacao-a-laser",
  "limpeza-de-pele",
];

export const SERVICE_IMAGES = {
  "cortes-finalizacao": "/assets/works/corte02.jpg",
  coloracao: "/assets/works/ruiva1.jpg",
  "mechas-balayage": "/assets/works/ba-after.jpg",
  "correcao-de-cor": "/assets/works/ruiva01.jpg",
  "tratamentos-capilares": "/assets/works/corte1-after.jpg",
  "cronograma-capilar": "/assets/works/coloc-after.jpg",
  "botox-alinhamento": "/assets/works/prog3-after.jpg",
  "progressiva-alisamentos": "/assets/works/prog2-after.jpg",
  "depilacao-a-laser": "/assets/depilacao-laser.png",
  "limpeza-de-pele": "/assets/limpeza-pele-argila.jpeg",
};

export const SERVICE_EXTRA_IMAGES = {
  "limpeza-de-pele": ["/assets/limpeza-pele-mascara.jpeg"],
};

const W = "/assets/works";

// Real client work only. Items with `pair` render as interactive before/after sliders.
export const TRANSFORMATIONS = [
  { pair: [`${W}/ba-before.jpg`, `${W}/ba-after.jpg`], cats: ["antesDepois", "balayage"], key: "balayage" },
  { pair: [`${W}/prog1-before.jpg`, `${W}/prog1-after.jpg`], cats: ["antesDepois", "progressiva"], key: "progressiva" },
  { pair: [`${W}/prog2-before.jpg`, `${W}/prog2-after.jpg`], cats: ["antesDepois", "progressiva"], key: "progressiva" },
  { pair: [`${W}/prog3-before.jpg`, `${W}/prog3-after.jpg`], cats: ["antesDepois", "progressiva"], key: "progressiva" },
  { pair: [`${W}/corte1-before.jpg`, `${W}/corte1-after.jpg`], cats: ["antesDepois", "cortes"], key: "corteBob" },
  { pair: [`${W}/coloc-before.jpg`, `${W}/coloc-after.jpg`], cats: ["antesDepois"], key: "colocacao" },
  { pair: [`${W}/loiro0-before.jpg`, `${W}/loiro0-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro4-before.jpg`, `${W}/loiro4-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro5-before.jpg`, `${W}/loiro5-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro6-before.jpg`, `${W}/loiro6-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro7-before.jpg`, `${W}/loiro7-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro8-before.jpg`, `${W}/loiro8-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro9-before.jpg`, `${W}/loiro9-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiro10-before.jpg`, `${W}/loiro10-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { pair: [`${W}/loiroX-before.jpg`, `${W}/loiroX-after.jpg`], cats: ["antesDepois", "balayage"], key: "loiro" },
  { img: `${W}/loiroS1.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS2.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS3.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS4.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS5.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS6.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS7.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS8.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS9.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS10.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS11.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS12.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/loiroS13.jpg`, cats: ["balayage"], key: "loiro" },
  { img: `${W}/ruiva01.jpg`, cats: ["coloracao"], key: "ruiva" },
  { img: `${W}/ruiva1.jpg`, cats: ["coloracao"], key: "ruiva" },
  { img: `${W}/corte02.jpg`, cats: ["cortes"], key: "corteBob" },
];

// Home preview — 4 real results
export const HOME_TRANSFORMATIONS = [
  { img: `${W}/ba-after.jpg`, cat: "balayage", key: "balayage" },
  { img: `${W}/prog1-after.jpg`, cat: "progressiva", key: "progressiva" },
  { img: `${W}/ruiva1.jpg`, cat: "coloracao", key: "ruiva" },
  { img: `${W}/corte1-after.jpg`, cat: "cortes", key: "corteBob" },
];

// Gallery — results, details and real videos of the work
export const GALLERY = [
  { img: `${W}/ba-after.jpg`, tag: "balayage", key: "balayage" },
  { img: `${W}/loiro0-after.jpg`, tag: "balayage", key: "loiro" },
  { img: `${W}/loiroS2.jpg`, tag: "balayage", key: "loiro" },
  { img: `${W}/loiroS5.jpg`, tag: "balayage", key: "loiro" },
  { img: `${W}/loiroS8.jpg`, tag: "balayage", key: "loiro" },
  { img: `${W}/loiroS11.jpg`, tag: "balayage", key: "loiro" },
  { img: `${W}/loiroS13.jpg`, tag: "balayage", key: "loiro" },
  { video: `${W}/video-loiro.mp4`, poster: `${W}/video-loiro.jpg`, tag: "balayage", key: "videoLoiro" },
  { img: `${W}/prog1-after.jpg`, tag: "progressiva", key: "progressiva" },
  { img: `${W}/prog2-after.jpg`, tag: "progressiva", key: "progressiva" },
  { img: `${W}/prog3-after.jpg`, tag: "progressiva", key: "progressiva" },
  { video: `${W}/video-progressiva.mp4`, poster: `${W}/video-progressiva.jpg`, tag: "progressiva", key: "videoProg" },
  { img: `${W}/ruiva01.jpg`, tag: "coloracao", key: "ruiva" },
  { img: `${W}/ruiva1.jpg`, tag: "coloracao", key: "ruiva" },
  { video: `${W}/video-ruiva.mp4`, poster: `${W}/video-ruiva.jpg`, tag: "coloracao", key: "videoRuiva" },
  { img: `${W}/corte1-after.jpg`, tag: "cortes", key: "corteBob" },
  { img: `${W}/corte02.jpg`, tag: "cortes", key: "corteBob" },
];
